import React, { useEffect, useRef, useState } from 'react'
import "./SlideScrollContent.css"
import { motion, useTransform, useScroll } from "framer-motion";
import CalendlyFormModal from '../CalendlyFormEmbed/CalendlyFormEmbed';

let cards

function SlideScrollContent({
  cardData,
  noContent=false
}) {
 const targetRef = useRef(null);
  const innerScrollRef = useRef(null);
  const scrollInProgress = useRef(false); 

  const [maxScroll, setMaxScroll] = useState(0);
  const [scrollValue, setScrollValue] = useState(0);
  const [horizontalScrollActive, setHorizontalScrollActive] = useState(false);

  cards = [
  {
    img: "/images/creatives/scrollslider-new-img-1.png",
    title: "Comprehensive Medical History Collection",
    para:' We begin by understanding your personal and family medical history to establish a strong clinical foundation.',
    number:"01",
    id: 1,
  },
  {
    img: "/images/creatives/scrollslider-new-img-2.png",
    title: "Multidisciplinary Health Assessments",
    para:'Our executive assessment includes:',
    number:"02",
    id: 2,
    shiftRow:true,
    listPoints:true
  },
  {
    img: "/images/creatives/scrollslider-new-img-3.png",
    title: "Personalized Health Strategy",
    para:'Your results are reviewed and synthesized into a tailored Health Action Plan, focusing on both risk mitigation and health optimization.',
    number:"03",
    id: 3,
    shiftRow:true
  },
  {
    img: "/images/creatives/scrollslider-new-img-4.png",
    title: "Ongoing Care and Monitoring",
    para:'Through monthly follow-ups, our clinical team proactively manages your care, adjusting for any changes and helping you stay accountable to your goals.',
    number:"04",
    id: 4,
    shiftRow:true
  },
  {
    img: "/images/creatives/scrollslider-new-img-5.png",
    title: "24/7 Access and Continuous Support",
    para:'From prescription renewals to acute concerns and health navigation abroad, you’re never on your own.',
    number:"05",
    id: 5,
    shiftRow:true
  },
  {
    img: "/images/creatives/scrollslider-new-img-6.png",
    title: "Curious to learn more?",
    para:' Want to better understand our program? Book a call with our team to get all your questions answered. You can also download our Prevention Booklet to explore how we help clients stay at their best year after year.',
    number:"06",
    id: 6,
    shiftRow:true,
    btn:"Book a consultation",
    lastCard:true
  },

];

  if(cardData)
  {
  cards = cardData
  }

  useEffect(() => {
    function updateMaxScroll() {
      if (innerScrollRef.current) {
        const clientWidth = innerScrollRef.current.clientWidth;
        setMaxScroll(clientWidth - window.innerWidth);
      }
    }

    updateMaxScroll();
    window.addEventListener("resize", updateMaxScroll);
    return () => window.removeEventListener("resize", updateMaxScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!targetRef.current) return;

      const rect = targetRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (rect.bottom <= viewportHeight) {
        setHorizontalScrollActive(true);
       } else {
        setHorizontalScrollActive(false);
        setScrollValue(0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    if (!horizontalScrollActive) return;

    const handleWheel = (e) => {
      if (!targetRef.current || scrollInProgress.current) return;

      const direction = e.deltaY > 0 ? 1 : -1;
      const scrollStep = window.innerWidth;

      e.preventDefault();
      scrollInProgress.current = true;

      setScrollValue((prev) => {
        let next = prev + direction * scrollStep;

        if (next >= maxScroll) {
          next = maxScroll;
          setHorizontalScrollActive(false);
          document.body.style.overflow = "";
        }

        if (next <= 0) {
          next = 0;
          setHorizontalScrollActive(false);
        }

        return next;
      });

      setTimeout(() => {
        scrollInProgress.current = false;
      }, 600); 
    };

    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, [horizontalScrollActive, maxScroll]);

// ============
let yScrollBlocked = false;

function blockYScroll(shouldBlock) {
  yScrollBlocked = shouldBlock;

  if (shouldBlock) {
    window.addEventListener("wheel", preventYScroll, { passive: false });
    window.addEventListener("touchmove", preventYScroll, { passive: false });
  } else {
    window.removeEventListener("wheel", preventYScroll);
    window.removeEventListener("touchmove", preventYScroll);
  }
}


function preventYScroll(e) {
  e.preventDefault(); 
}

useEffect(() => {
  const handleLoad = () => {
    blockYScroll(false);
  };

  // Run when window fully loads
  if (document.readyState === "complete") {
    handleLoad();
  } else {
    window.addEventListener("load", handleLoad);
  }

  return () => window.removeEventListener("load", handleLoad);
}, []);


 const ref0 = useRef(null);
 const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref4 = useRef(null);

  const [isOnScreen0, setIsOnScreen0] = useState(false);
  const [isOnScreen1, setIsOnScreen1] = useState(false);
  const [isOnScreen2, setIsOnScreen2] = useState(false);
  const [isOnScreen4, setIsOnScreen4] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {

          if (entry.target === ref1.current) {
            
            setIsOnScreen1(entry.isIntersecting);
            if(entry.isIntersecting)
            {
              blockYScroll(true)
            }
          } else if (entry.target === ref2.current) {
            setIsOnScreen2(entry.isIntersecting);
            if(entry.isIntersecting)
            {
              blockYScroll(false)
            }
          }
          else if (entry.target === ref4.current) {
            setIsOnScreen4(entry.isIntersecting);
            if(entry.isIntersecting)
            {
              blockYScroll(true)
            }
          }
          else if (entry.target === ref0.current) {
            setIsOnScreen0(entry.isIntersecting);
            if(entry.isIntersecting)
            {
              blockYScroll(false)
            }
          }

        });
      },
      {
        root: null, 
        rootMargin: "0px",
        threshold: 1,
      }
    );

    if (ref0.current) observer.observe(ref0.current);
    if (ref1.current) observer.observe(ref1.current);
    if (ref2.current) observer.observe(ref2.current);
    if (ref4.current) observer.observe(ref4.current);

    return () => {
  if (ref0.current) observer.unobserve(ref0.current);
  if (ref1.current) observer.unobserve(ref1.current);
  if (ref2.current) observer.unobserve(ref2.current);
  if (ref4.current) observer.unobserve(ref4.current);
};

  }, []);


  // ========= ARROWs controls
  const scrollByStep = (direction) => {
  if (!innerScrollRef.current) return;

  const scrollStep = window.innerWidth; // same as wheel logic

  setScrollValue((prev) => {
    let next = prev + direction * scrollStep;

    if (next >= maxScroll) {
      next = maxScroll;
      setHorizontalScrollActive(false);
      document.body.style.overflow = "";
    }

    if (next <= 0) {
      next = 0;
      setHorizontalScrollActive(false);
    }

    return next;
  });
};

const handleArrowRight = () => {
  setHorizontalScrollActive(true);
  scrollByStep(1);
};

const handleArrowLeft = () => {
  setHorizontalScrollActive(true);
  scrollByStep(-1);
};


// ============

  const [openCalendly, setOpenCalendly] = useState(false);

  return (
    <div className="slider-wrapper">
         {
            openCalendly &&
            <CalendlyFormModal intialOpenState={openCalendly} setOpenState={setOpenCalendly} calendlyType={1}/>
        }
      <div className="container pt-5 d-flex align-items-center justify-content-between">
        {
          !noContent &&
          <div className="row">
            <div className="col-lg-6">
              {/* <h5 className="sub-heading color-blue">Redefining Healthcare</h5> */}
              <div className="d-flex align-items-center gap-2 my-3">
                <h3 className="body-heading">
                  A Clear Path Toward <br />
                  Your <span className="color-blue">Optimal Health</span>
                </h3>
                <img
                  src="/images/icons/icon-logo.png"
                  className="img-fluid"
                  style={{ maxWidth: "100px" }}
                  alt="icon"
                />
              </div>
              <p className="body-paragraph">
                 Our program follows a step-by-step, data-driven methodology to create lasting transformation in your health and well-being.
              </p>
            </div>
          </div>
        }
        <div className='d-flex align-items-center gap-3'>
         
        <img src="/images/icons/indus-carousel-arrow-left.png" onClick={handleArrowLeft} alt="arrow icon" className='img-fluid cursor-pointer'/>
        <img src="/images/icons/indus-carousel-arrow-right.png" onClick={handleArrowRight} alt="arrow icon" className='img-fluid cursor-pointer'/>
    
        </div>
      </div>

      <div
        className="view-container"
        style={{ width: "99vw", overflowX: "hidden" }}
        ref={targetRef}
      >
        
        <div
          style={{
            transform: `translateX(-${scrollValue}px)`,
            transition: "transform 0.4s ease-out",
            width: "max-content",
          }}
          ref={innerScrollRef}
        >
          <div className="d-flex flex-lg-row flex-column">
            {cards.map((card, i) => (
              
              <div key={i} style={{ width: "100vw" }} 
              >
                {
                  card?.lastCard ?
                  <div className="container my-lg-0 my-2" ref={ref2}>
                    <div
                      className={`row gy-lg-0 gy-4 pt-4 ${
                        card?.shiftRow ? "flex-row-reverse" : ""
                      }
                      ${card?.img?"":"justify-content-center"}
                      
                      `}
                    >
                      <div className={` ${card?.img?"col-lg-6":"col-lg-4 mb-4"} pt-4 pt-lg-0 d-flex align-items-start`} style={{height:"auto"}}>
                        <div className="card-box p-4" style={{minHeight:"70%",
                          background: "#000000",
                          background: "linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(51, 56, 87, 1) 50%)"
    
                          }}>
                          
                          <h5 className="sub-heading color-blue" style={{ fontSize: "30px",textTransform:'none' }}>
                            {
                              card?.number == "06"
                              ?
                              "Last step:"

                              :
                              `Step ${card?.number}:`

                            }
                          </h5>
                          <h3 className="body-heading" style={{ fontSize: "1.6rem",color:"white" }}>
                            {card?.title}
                          </h3>
                          <p className="body-paragraph" style={{color:"white"}}>{card?.para}</p>
                          {
                              card?.listPoints &&
                              <div className='d-flex align-items-start gap-1'>
                                  <ul>
                                      <li>Executive Medical</li>
                                      <li>Cardiovascular Risk</li>
                                      <li>Cancer Risk</li>
                                      <li>Women’s and Men’s Health</li>
                                  </ul>
                                  <ul>
                                      <li>Stress and Wellness</li>
                                      <li>Nutrition</li>
                                      <li>Fitness and Physiology</li>
                                      <li>Naturopathic Assessment</li>
                                      <li>Sports Medicine</li>
                                  </ul>
                              </div>
                          }
                          {
                            card?.btn &&

                            <button className='genral-btn' onClick={()=>{setOpenCalendly(true)}}>{card?.btn}</button>
                          }
                          {/* {
                            card?.lastCard &&

                            <button className='genral-btn ms-1' style={{background:"white",color:"black"}}>Download pdf guide</button>
                          } */}
                        </div>
                      </div>
                      <div className={`${card?.img?"col-lg-6":"col-0"} d-flex `}>
                        {/* <img
                          src={card?.img}
                          alt="content"
                          className={`img-fluid mx-auto mt-3 ${!card?.img && "d-none"}`}
                          style={{ borderRadius: "20px",boxShadow: "0px 3px 10px 2px rgba(0,0,0,0.16)" }}
                        /> */}
                         <div className='' style={{ backgroundImage:`url(${card?.img})`,backgroundSize:"cover",backgroundRepeat:"no-repeat",borderRadius: "20px",boxShadow: "0px 3px 10px 2px rgba(0,0,0,0.16)",  width:"100%", maxHeight:"450px",minHeight:"380px" }}>

                        </div>

                      </div>
                    </div>
                  </div>
                  :
                  <div className="container my-lg-0 my-2"  ref={i === 0 ? ref0 : i === 1 ? ref1 : i === 4 ? ref4 : null}>
                    <div
                      className={`row gy-lg-0 gy-4 pt-4 ${
                        card?.shiftRow ? "flex-row-reverse" : ""
                      }
                      ${card?.img?"":"justify-content-center"}
                      
                      `}
                    >
                      <div className={` ${card?.img?"col-lg-6":"col-lg-4 mb-4"} pt-4 pt-lg-0 d-flex align-items-start`} style={{height:"auto"}}>
                        <div className="card-box p-4" style={{minHeight:"70%"}}>
                          
                          <h5 className="sub-heading color-blue" style={{ fontSize: "30px",textTransform:'none' }}>
                            {
                              card?.number == "06"
                              ?
                              "Last Step:"

                              :
                              `Step ${card?.number}:`

                            }
                          </h5>
                          <h3 className="body-heading" style={{ fontSize: "1.6rem" }}>
                            {card?.title}
                          </h3>
                          <p className="body-paragraph">{card?.para}</p>
                          {
                              card?.listPoints &&
                              <div className='d-flex align-items-start gap-1'>
                                  <ul>
                                      <li>Executive Medical</li>
                                      <li>Cardiovascular Risk</li>
                                      <li>Cancer Risk</li>
                                      <li>Women’s and Men’s Health</li>
                                  </ul>
                                  <ul>
                                      <li>Stress and Wellness</li>
                                      <li>Nutrition</li>
                                      <li>Fitness and Physiology</li>
                                      <li>Naturopathic Assessment</li>
                                      <li>Sports Medicine</li>
                                  </ul>
                              </div>
                          }
                          {
                            card?.btn &&

                            <button className='genral-btn' onClick={()=>{setOpenCalendly(true)}}>{card?.btn}</button>
                          }
                        </div>
                      </div>
                      <div className={`${card?.img?"col-lg-6":"col-0"} d-flex `}>
                        {/* <img
                          src={card?.img}
                          alt="content"
                          className={`img-fluid mx-auto mt-3 ${!card?.img && "d-none"}`}
                          style={{ borderRadius: "20px",boxShadow: "0px 3px 10px 2px rgba(0,0,0,0.16)" }}
                        /> */}
                        <div className='' style={{ backgroundImage:`url(${card?.img})`,backgroundSize:"cover",backgroundRepeat:"no-repeat",borderRadius: "20px",boxShadow: "0px 3px 10px 2px rgba(0,0,0,0.16)", width:"100%", maxHeight:"450px", minHeight:"380px" }}>

                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            ))}
          </div>

          {/* Progress Bar */}
          <div className="w-100 my-3 position-relative" style={{ height: "5px" }}>
            <div
              style={{
                width: `${scrollValue + window.innerWidth / 2}px`,
                transform: `translateX(${window.innerWidth / 2}px)`,
                maxWidth: `${maxScroll}px`,
                height: "100%",
                position: "absolute",
                background: "silver",
                top: 0,
                left: 0,
              }}
            ></div>

            <div
              style={{
                backgroundColor: "#208AE7",
                width: `${scrollValue}px`,
                height: "100%",
                position: "absolute",
                top: 0,
                left: `${window.innerWidth / 2}px`,
                maxWidth: `${maxScroll}px`,
              }}
            ></div>

            <div
              style={{
                width: "16px",
                height: "16px",
                backgroundColor: "#208AE7",
                borderRadius: "50%",
                position: "absolute",
                top: "-6px",
                left: `${scrollValue + window.innerWidth / 2 - 8}px`,
              }}
            ></div>
          </div>
        </div>
       
      </div>
    </div>
  );
}


export default SlideScrollContent


const HorizontalScrollCarousel = () => {
    
  const [barWidth, setBarWidth] = useState(0);
  const targetRef = useRef(null);
  const progressBarRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
  });

  useEffect(() => {
    if (progressBarRef.current) {
      setBarWidth(progressBarRef.current.offsetWidth);
    }
    const handleResize = () => {
      if (progressBarRef.current) {
        setBarWidth(progressBarRef.current.offsetWidth);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const x = useTransform(scrollYProgress, [0, 1], ["-85.4%", "0%"]);
  const thumbX = useTransform(scrollYProgress, [0, 1], [0, barWidth]);

  return (
    <section ref={targetRef} className="carousel-section ">
         
      <div className="carousel-track-wrapper pb-5 ">
        <motion.div style={{ x: useTransform(scrollYProgress, [0, 1], ["-81.4%", "0%"]) }} className="carousel-track">
            
          {cards.map((card) => (
            <Card card={card} key={card.id} />
          ))}
        </motion.div>

        {/* Progress bar */}
        <div ref={progressBarRef} className="scroll-progress-container ">
          <div className="scroll-progress-track" />
          <motion.div
            className="scroll-progress-fill"
            style={{
              scaleX: scrollYProgress,
              transformOrigin: "left",
            }}
          />
          <motion.div
            className="scroll-progress-thumb"
            style={{
              x: thumbX,
            }}
          />
        </div>
      </div>
    </section>
  );
};


const Card = ({ card }) => {
  return (
    <div className="card " style={{width:"99vw"}}>
       
        
        <div className='container'>
            <div className={`row gy-lg-0 gy-4 align-items-center ${card?.shiftRow && "flex-row-reverse"}`}>
                <div className='col-lg-6'>
                    <div className='card-box p-4'>
                        <h5 className='sub-heading color-blue'>{card?.number}</h5>
                        <h3 className='body-heading' style={{fontSize:"1.6rem"}}>{card?.title}</h3>
                        <p className='body-paragraph'>{card?.para}</p>

                        {
                            card?.listPoints &&
                            <div className='d-flex align-items-start gap-1'>
                                <ul>
                                    <li>Executive Medical</li>
                                    <li>Cardiovascular Risk</li>
                                    <li>Cancer Risk</li>
                                    <li>Women’s and Men’s Health</li>
                                </ul>
                                <ul>
                                    <li>Stress and Wellness</li>
                                    <li>Nutrition</li>
                                    <li>Fitness and Physiology</li>
                                    <li>Naturopathic Assessment</li>
                                    <li>Sports Medicine</li>
                                </ul>
                            </div>
                        }
                    </div>
                </div>
                <div className='col-lg-6 d-flex'>
                    <img src={card?.img} alt='content' className='img-fluid mx-auto' style={{borderRadius:"20px"}} />
                </div>

            </div>

        </div>
    </div>
  );
};


